import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var dictionary = {
  bezlimit_inet: 'infinitInternet',
  bezlimit: 'infinitCalls',
  '10rub': 'tenRub'
};
export default function Emoji(_ref) {
  var name = _ref.name,
    path = _ref.path,
    className = _ref.className;
  if (!name && !path) return null;
  var realName = dictionary[name] || name;
  var src = realName ? "https://static.beeline.ru/upload/images/emoji/".concat(realName, ".svg") : path;
  return /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx(className),
    role: "presentation",
    src: src
  });
}
Emoji.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  className: PropTypes.any,
  path: PropTypes.string
} : {};